import React, { useMemo } from 'react';

import { Teams } from '@vyce/core/src/views/teams';
import { TeamListModuleProvider } from '@vyce/core/src/contexts';
import { getStaffRequest } from '@vyce/core/src/api/companies';

import { useCreateTeam, useTeamsListData } from './hooks';
import { useTypedSelector } from '../../hooks';

const Wrapper = ({ children }: { children: React.ReactElement }) => {
  const createTeamHookData = useCreateTeam();
  const teamsListHookData = useTeamsListData();
  const { selectedCompany } = useTypedSelector(state => state.helper);

  const value = useMemo(
    () => ({
      ...teamsListHookData,
      ...createTeamHookData,
      selectedCompanyId: selectedCompany?.uuid,
      getStaffRequest,
    }),
    [createTeamHookData, teamsListHookData, selectedCompany?.uuid]
  );

  return <TeamListModuleProvider value={value}>{children}</TeamListModuleProvider>;
};

export const TeamsListModule = () => (
  <Wrapper>
    <Teams />
  </Wrapper>
);

export const GetStartedModule = (props: { hasPermissions?: boolean; hadSubscription?: boolean }) => (
  <Wrapper>
    <Teams.GetStarted {...props} />
  </Wrapper>
);
